import { render, staticRenderFns } from "./teacherProfile.vue?vue&type=template&id=112cff2e&scoped=true"
import script from "./teacherProfile.vue?vue&type=script&lang=js"
export * from "./teacherProfile.vue?vue&type=script&lang=js"
import style0 from "./teacherProfile.vue?vue&type=style&index=0&id=112cff2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112cff2e",
  null
  
)

export default component.exports